import { __awaiter, __rest } from "tslib";
import React, { useState } from 'react';
import Button from '../Button';
import { copyToClipboard } from '../../../../html/utils';
import { CdnIcon } from '@shared/ui';
import { useTranslation } from 'react-i18next';
const CopyButton = (_a) => {
    var { text, copyButtonText, copiedButtonText, iconPosition = 'left', onClick } = _a, buttonProps = __rest(_a, ["text", "copyButtonText", "copiedButtonText", "iconPosition", "onClick"]);
    const { t } = useTranslation('');
    const [copied, setCopied] = useState(false);
    const handleCopy = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        try {
            yield copyToClipboard(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
        catch (err) {
            console.error('Ошибка при копировании: ', err);
        }
    });
    const icon = React.createElement(CdnIcon, { icon: copied ? 'Info/Check' : 'Action/Copy' });
    const startIcon = iconPosition === 'left' ? icon : null;
    const endIcon = iconPosition === 'right' ? icon : null;
    const copyText = copyButtonText || t('Copy');
    const copiedText = copiedButtonText || t('Copied!');
    return (React.createElement(Button, Object.assign({ onClick: handleCopy, startIcon: startIcon, endIcon: endIcon }, buttonProps), copied ? copiedText : copyText));
};
export default CopyButton;
